// # configure scroll magic and gsap
import ScrollMagic from 'scrollmagic'
import { ScrollMagicPluginGsap } from "scrollmagic-plugin-gsap";
import { gsap } from 'gsap'
// GSAP plugins
ScrollMagicPluginGsap(ScrollMagic, gsap)

class ScrollController {
  /**
  * @constructor
  **/
  constructor() {
    this.controller = null
  }
  // Build ScrollMagic Controller
  _build() {
    this.destroy()
    this.controller = new ScrollMagic.Controller({
      loglevel: 0
    }) 
  }
  get() {
    if (!this.controller) {
      this._build()
    }
    return this.controller
  }
  destroy() {
    if (this.controller) {
      this.controller.destroy()
      this.controller = null
    }
  }
  refresh(immediately = false) {
    if (this.controller) {
      this.controller.update(immediately)
    } else {
      console.warn("Can't refresh ScrollMagic.Controller. Controller was not build")
    }
  }
}
const scrollController = new ScrollController();
export default scrollController;